export default "__VITE_ASSET__CuM7ErPL__"